import React, { useEffect, useState } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  FormOutlined,
} from '@ant-design/icons'
import { toast } from 'react-toastify'
import apiRequest from '../../hooks/ApiRequest'
import AddEditForm from './AddEditForm'
import Layouts from '../../components/Layouts'
import { useHistory } from 'react-router-dom'
import CommonSearch from '../../hooks/Search'

const ClaimFormPage = () => {
  const [claimForms, setClaimForms] = useState([])
  const navigate = useHistory()
  const [allForms, setAllForms] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [products, setProducts] = useState([])
  const [insurers, setInsurers] = useState([])

  const [selectedClaimId, setSelectedClaimId] = useState(null)

  useEffect(() => {
    fetchClaimForms()
    loadProducts()
    fetchInsurers()
  }, [])

  const fetchInsurers = async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`
      const res = await apiRequest(url, 'GET')
      const data = res?.data || []
      // Map to id, name shape
      setInsurers(
        data.map(i => ({
          id: i.userId ?? i.id,
          name: i.userName ?? i.name,
        })),
      )
    } catch (err) {
      toast.error('Failed to fetch insurers')
    }
  }

  const loadProducts = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetAllProducts`,
        'GET',
      )
      if (!res?.success) throw new Error('Failed to fetch products')

      const items = res?.data?.data || []
      if (items.length === 0) {
        toast.warning('No products available')
        return
      }
      setProducts(items)
    } catch (err) {
      console.error(err)
      toast.error('Failed to load products')
    }
  } // ⬅️ Missing this line

  const fetchClaimForms = async () => {
    setLoading(true)
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm`,
        'GET',
      )
      const result = Array.isArray(res) ? res : res?.data
      if (Array.isArray(result)) {

        const insurerId = localStorage.getItem('insurerId')
          ? parseInt(localStorage.getItem('insurerId'), 10)
          : null;

        
        const filtered = result.filter(item => item.insurerId === insurerId);

        setAllForms(filtered)
        setClaimForms(filtered)
      } else {
        toast.error('Failed to load claim forms')
      }
    } catch (err) {
      toast.error('Error fetching claim forms')
    } finally {
      setLoading(false)
    }
  }

  const handleAdd = () => {
    setSelectedId(null)
    setModalVisible(true)
  }

  const handleEdit = id => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const handleFieldEdit = id => {
    navigate.push(`/home/claim/manage-claim-field/${id}`)
  }

  const handleDelete = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/delete/${id}`,
        'POST',
      )
      if (res?.success || res?.message?.toLowerCase().includes('deleted')) {
        toast.success('Form deleted successfully')
        fetchClaimForms()
      } else {
        toast.error(res.message || 'Delete failed')
      }
    } catch (err) {
      toast.error('Error deleting form')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    setSelectedId(null)
    fetchClaimForms()
  }

  const columns = [
    // {
    //     title: 'ID',
    //     dataIndex: 'id',
    //     key: 'id',
    //     width: 100,
    // },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Insurer',
      dataIndex: 'insurerId',
      key: 'insurerId',
      render: id => insurers.find(i => i.id === id)?.name || 'N/A',
    },

    {
      title: 'Product',
      dataIndex: 'productId',
      key: 'productId',
      render: productId => {
        const product = products.find(p => p.productid === productId)
        return product?.productname || 'N/A'
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 150,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>

          <Tooltip title="Manage Form Fields">
            <Button
              style={{
                backgroundColor: '#4B9CD3',
                color: '#fff',
                border: 'none',
              }}
              onClick={() => handleFieldEdit(record.id)}>
              <FormOutlined />
            </Button>
          </Tooltip>

          <Popconfirm
            title="Are you sure to delete this form?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger">
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ]
  const handleSearch = value => {
    const filterTable = claimForms.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setClaimForms(filterTable)
  }
  const ClearSerach = () => {
    setSearchTerm('')
    setClaimForms(claimForms)
    fetchClaimForms()
  }
  return (
    <div title="Claim Forms" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Claim Forms
              </h3>
            </div>
          </Col>

          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>

          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <Button type="primary" onClick={() => handleSearch(searchTerm)}>
              Search
            </Button>
          </Col>

          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <Button type="primary" onClick={handleAdd}>
              Add Form
            </Button>
          </Col>
        </Row>
      </div>
      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ marginTop: 20 }}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={claimForms}
          rowKey={record => record.id || record.ID}
        />
      )}

      <Modal
        title={selectedId ? 'Edit Form' : 'Add Form'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}
        destroyOnClose>
        <AddEditForm
          claimFormId={selectedId}
          onSuccess={handleModalClose}
          products={products}
          insurers={insurers}
        />
      </Modal>
    </div>
  )
}

export default ClaimFormPage
